import { Permissions } from '@package/jwt/nuxt'

export const useCanWriteContent = () => {
  const { session } = useUserSession()
  return computed(() => {
    const permissions = session.value?.permissions ?? []
    return (
      permissions.includes(Permissions.writeTeamContent) ||
      permissions.includes(Permissions.writeSystem)
    )
  })
}
